var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"border":"1px solid red"},attrs:{"id":"myapp"}},[_vm._v("\n  dfgsdgsdgsgs\n")])}
var staticRenderFns = []

export { render, staticRenderFns }